import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { AuxEnvioExViewModel } from '../envioEx.types';
import { CopiaCertificadoExItemViewModel, CopiaCertificadoExViewModel, SolicitudCopiaCertificadoExViewModel } from './copiaCFEx.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class CopiaCFExService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getSolicitudCopiaCertificadoEx(idSol: number): Observable<SolicitudCopiaCertificadoExViewModel> {
        return this.http.get<SolicitudCopiaCertificadoExViewModel>(this.baseUrl + 'api/exportacion/envioex/solicitudCopiaCertificadoEx/new/' + idSol).pipe();
    }

    getDataByIdSolicitudEx(idSol: number): Observable<CopiaCertificadoExItemViewModel[]> {
        return this.http.get<CopiaCertificadoExItemViewModel[]>(this.baseUrl + 'api/exportacion/envioex/CopiasDataSolicitudEx/' + idSol).pipe();
    }

    getCopiasCertificadoEx(idSol: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/exportacion/envioex/CopiasSolicitudEx/' + idSol).pipe();
    }

    createCopia(copia: CopiaCertificadoExViewModel): Observable<any> {
        return this.http
            .post<CopiaCertificadoExViewModel>(this.baseUrl + 'api/exportacion/envioex/solicitudCopiaCertificadoEx/postInsertTCopiaCertificadoEx', copia)
            .pipe();
    }

    editCopia(copia: CopiaCertificadoExViewModel): Observable<any> {
        return this.http
            .put<CopiaCertificadoExViewModel>(this.baseUrl + 'api/exportacion/envioex/solicitudCopiaCertificadoEx/putUpdateTCopiaCertificadoEx', copia)
            .pipe();
    }

    deleteCopia(id: number): Observable<any> {
        return this.http
            .delete<CopiaCertificadoExViewModel>(this.baseUrl + 'api/exportacion/envioex/solicitudCopiaCertificadoEx/deleteTCopiaCertificadoEx/' + id)
            .pipe();
    }

    getCopia(idCopia: number): Observable<CopiaCertificadoExViewModel> {
        return this.http.get<CopiaCertificadoExViewModel>(this.baseUrl + 'api/exportacion/envioex/solicitudCopiaCertificadoEx/' + idCopia).pipe();
    }

    emitCopiaCertificadoFitosanitario(auxEnvioEx: AuxEnvioExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/solicitudCopiaCertificadoEx/PostExportPdfCopia', auxEnvioEx, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    anularCopiaCertificadoFitosanitario(auxEnvioEx: AuxEnvioExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/solicitudCopiaCertificadoEx/anularCopia', auxEnvioEx, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    getCertificadoFitosanitarioCopia(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/solicitudCopiaCertificadoEx/GetPdfCertificadoFitosanitarioCopia', idSolicitud, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }
}
